<div class="filter-container" [ngClass]="{ 'right-justify': rightJustify }">
  @if (filterOptions.length > 0) {
    <div class="filter-content">
      <h2 class="filter-title">{{ filterTitle }}</h2>
      <section class="section-container">
        @for (item of options; track item; let i = $index) {
          <span tabindex="0" (keyup.enter)="$event.target.querySelector('input')?.click()" data-cy="class-name-label" attr.aria-label="{{ item.name }}">
            <mat-checkbox data-cy="checkbox-template-category" [attr.data-cy-checkbox-template-id]="i" class="filter-checkbox" name="categoryCheck" id="option_{{ i + 1 }}" [(ngModel)]="item.checked" tabindex="0">
              {{ item.name }}
            </mat-checkbox>
          </span>
        }
      </section>
    </div>
  }

  @if (options?.length === 0) {
    <div class="filter-content pt-5 pl-5 pb-5 pr-5">No {{ filterTitle | lowercase }} found</div>
  }

  <div class="filter-footer text-center">
    <button mat-flat-button class="mat-secondary" [disabled]="!canApplyFilter()" (click)="clearFilter()" id="clearFIlterPopup" data-cy="filter-popup-clear-button">Clear</button>
    <button data-cy="filter-popup-apply-button" mat-flat-button class="mat-primary" [disabled]="!canApplyFilter()" (click)="apply()" id="applyFIlterPopup">Apply</button>
  </div>
</div>
